import React from 'react';
import CampusHiringSection from '../components/RecruiterDashboard/CampusHiringSection';
import AssessmentHiringSection from '../components/RecruiterDashboard/AssessmentHiringSection';
import PositionHiringSection from '../components/RecruiterDashboard/PositionHiringSection';
import { Button } from 'flowbite-react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import useDisclosure from 'src/hooks/utils/useDisclosure';
import CreatePostionModal from 'src/components/recruiterPositions/recruiterTypes/Modals/CreatePostionModal';
import { Drawer } from 'src/components/shared/Drawer';
import { useHiringAssessmentDashboard } from 'src/hooks/hiringAssessment.hooks';

const RecruiterDashboard = () => {
	const router = useNavigate();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const handleAddHiring = () => {
		// console.log('Add Hiring');
		router('/select-hiring-type');
	};

	return (
		<div className="flex flex-col items-center">
			<Drawer isOpen={isOpen} isModal={true} onClose={() => onClose()} header={<></>} body={<CreatePostionModal />} />
			<CampusHiringSection />
			<AssessmentHiringSection />
			<PositionHiringSection />
		</div>
	);
};

export default RecruiterDashboard;
